export const environment = {
  production: true,
  buildId: '3413515507322021',
  configFile: 'config.json',
};
